import React from 'react';
import { Modal } from 'antd';

const ResponsiveModal = ({ 
  children, 
  className = '', 
  width,
  ...props 
}) => {
  // Default responsive widths
  const getResponsiveWidth = () => {
    if (width) return width;
    
    // Return responsive width based on screen size
    if (window.innerWidth <= 480) {
      return '95vw';
    } else if (window.innerWidth <= 768) {
      return '90vw';
    } else {
      return 800;
    }
  };

  return (
    <Modal
      {...props}
      width={getResponsiveWidth()}
      className={`responsive-modal ${className}`}
      style={{
        top: window.innerWidth <= 768 ? 20 : 100,
        ...props.style
      }}
      bodyStyle={{
        padding: window.innerWidth <= 480 ? 15 : 24,
        ...props.bodyStyle
      }}
    >
      {children}
    </Modal>
  );
};

export default ResponsiveModal;
